export type LinkEntry = { id: string; value: string; gameLinkId?: number };

export type DiscoverGameLinkItem = { id: number; link: string };

let nextLinkId = 0;

export function createLinkEntry(value = ""): LinkEntry {
	return { id: `link-${++nextLinkId}`, value };
}

export function normalizeOptionalLinks(links: LinkEntry[]): string[] {
	return links
		.map((entry) => entry.value.trim())
		.filter((v) => v.length > 0);
}

export function linksFromApiItems(
	items: DiscoverGameLinkItem[] | null | undefined,
): LinkEntry[] {
	if (items === null || items === undefined || items.length === 0) {
		return [createLinkEntry()];
	}

	return items.map((item) => ({
		id: `link-${item.id}`,
		gameLinkId: item.id,
		value: item.link,
	}));
}

/** @deprecated Program-game create still uses string URLs from the form. */
export function linksFromApiStrings(urls: string[] | null | undefined): LinkEntry[] {
	if (urls === null || urls === undefined || urls.length === 0) {
		return [createLinkEntry()];
	}

	return urls.map((url) => createLinkEntry(url));
}

export function removeLinkAt(links: LinkEntry[], index: number): LinkEntry[] {
	const next = links.filter((_, linkIndex) => linkIndex !== index);

	return next.length > 0 ? next : [createLinkEntry()];
}
